
export const campaign_modify_section_check = (type, data) => {
  switch (type) {
    case 'budget':
      return {
        section_name: data.payload.section_name,
        monthly_budget_units: data.payload.monthly_budget_units,
        monthly_dollar_budget: data.payload.monthly_dollar_budget,
        data: data.payload.data,
      };
    case 'modifiers':
      return {
        section_name: data.payload.section_name,
        data: data.payload.data,
        copy_modifiers_to: data.payload.copy_modifiers_to,
      };
    case 'filters':
      return {
        section_name: data.payload.section_name,
        data: data.payload.data,
        copy_filters_to: data.payload.copy_filters_to,
      };
    case 'schedule':
      return {
        section_name: data.payload.section_name,
        data: data.payload.data,
        timezone: data.payload.timezone,
        copy_schedule_to: data.payload.copy_schedule_to,
      };
    case 'type':
      return {
        section_name: data.payload.section_name,
        name: data.payload.name,
        active: data.payload.active,
        lead_type: data.payload.lead_type,
        product_type: data.payload.product_type,
        shared_lead_type: data.payload.shared_lead_type,
      };
    case 'tracking':
      return {
        section_name: data.payload.section_name,
        campaign_tracking_level: data.payload.campaign_tracking_level,
        dest_url: data.payload.dest_url,
        fallback_url: data.payload.fallback_url,
        postback_url: data.payload.postback_url,
        phone_num: data.payload.phone_num,
        email: data.payload.email,
        connector: data.payload.connector,
        api_key: data.payload.api_key,
        api_sid: data.payload.api_sid,
        post_url: data.payload.post_url,
        lead_integrations: data?.payload?.lead_integrations || null,
        has_click_integration: data.payload.has_click_integration,
        click_integration_id: data.payload.click_integration_id,
        append_tracking: data.payload.append_tracking,
        email_opted_out: data.payload.email_opted_out,
        quote_funnels: data.payload.quote_funnels,
        is_sip: data.payload.is_sip,
      };
    case 'filter_packages':
      return {
        section_name: data.payload.section_name,
        data: data.payload.data,
        delete_existing_filters: data.payload.delete_existing_filters,
      };
    default:
      return data.payload;
  }
};
